export default {
  complete: false,
  title: "Double Leg Line Jump Forward/Backward",
  training: {
    title: "repetitions",
    amount: "2 sets of 10 (hold for 2 seconds)",
  },
  equipmentNeeded: ["Floor"],
  media: "./assets/images/exercises/linejumpforward.gif",
  description:
    "With both feet together, jump forward and backwards over a line or cone, holding for 2 seconds after each jump.",
};
